import type * as React from 'react'

import { styled } from 'styled-components'

import { SharedFooter } from '@b-stock/fe-core/bstock-react'

import { PageWidth } from '@/components/PageWidth'

const FooterBody = styled(PageWidth)``

export const Footer: React.FC = () => {
  return (
    <FooterBody>
      <SharedFooter />
    </FooterBody>
  )
}
